import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search/types";
import { createCancelable } from "app/pages/workspace/sales/helpers";
import type { IFetchService } from "app/services/fetchService";

import type {
    AddExportSettingsRequest,
    ExportDomainsResponse,
    ExportSettingResponse,
    ExportType,
    HubspotPreDefinedType,
    SaveExportSettingsResponse,
} from "../../type";

export const createHubspotExportSettingsApiService = (fetchService: IFetchService) => {
    const getExportPath = (leadsType: LeadsType): string => {
        if (leadsType === "companies") {
            return "sales-api/hubspot/export/companies/accounts";
        }

        return "sales-api/hubspot/export/accounts";
    };

    return {
        getExportSettings: createCancelable(
            (signal: AbortSignal, type: ExportType): Promise<ExportSettingResponse[]> => {
                return fetchService.get(`sales-api/hubspot/mapping-field?type=${type}`, undefined, {
                    cancellation: signal,
                });
            },
        ),
        fetchHsExportSettings(cancellation: AbortSignal) {
            return fetchService.get<ExportSettingResponse[]>(`sales-api/hubspot/mapping-field`, undefined, {
                cancellation,
            });
        },
        saveExportSettings: (
            settings: AddExportSettingsRequest,
            type: HubspotPreDefinedType,
        ): Promise<SaveExportSettingsResponse> => {
            return fetchService.post(`sales-api/hubspot/mapping-field/export/${type}`, settings);
        },
        exportDomainsTo: createCancelable(
            (
                signal: AbortSignal,
                domains: readonly string[],
                countries: readonly number[],
                leadsType: LeadsType,
                listId?: string,
            ): Promise<ExportDomainsResponse> => {
                return fetchService.post(
                    getExportPath(leadsType),
                    { domains, countries, listId },
                    {
                        cancellation: signal,
                    },
                );
            },
        ),
    };
};
